/* ========================================================================
 * .noConflict()
 * Enclosed everything within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
    /// is onscreen function
    $.fn.isOnScreen = function () {

        var win = $(window);

        var viewport = {
            top: win.scrollTop(),
            left: win.scrollLeft()
        };

        viewport.right = viewport.left + win.width();
        viewport.bottom = viewport.top + win.height();

        var bounds = this.offset();
        bounds.right = bounds.left + this.outerWidth();
        bounds.bottom = bounds.top + this.outerHeight();

        return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

    };

    var scrollTimeout;
    var throttle = 50;

    function scroll_function(scroll) {
        if (!scrollTimeout) {
            scrollTimeout = setTimeout(function () {
                var st = $(this).scrollTop();

                checkDivs();

                scrollTimeout = null;
            }, throttle);
        }

        lazy();
    }

    scroll_function($(window).scrollTop());

    /// Scroll animations
    $(window).on('scroll', function () {
        var scroll = $(this).scrollTop();
        scroll_function(scroll);

        if(scroll > 100){
            $('header').addClass('scroll');
        }else{
            $('header').removeClass('scroll');
        }


        lazy();
    });

    function lazy() {
        $('img.lazy').each(function () {
            if ($(this).isOnScreen()) {
                $(this).attr('src', $(this).attr('data-src'));
                $(this).removeClass('lazy');

                if ($(this).parent().hasClass('liquid')) {
                    $(this).parent().css('background-image', 'url(' + $(this).attr('data-src') + ')');
                }
            }
        });
    }
    lazy();

    var checkDivs = function () {
        $('.anim.start').each(function () {
            if ($(this).isOnScreen() === true) {
                var anim = $(this).attr('data-anim');
                var speed = $(this).attr('data-speed');
                var delay = $(this).attr('data-delay');

                if (speed === null) {
                    speed = 700;
                }

                if (anim === 'fadeUp') {
                    $(this).velocity({translateZ: 0, translateY: '-30px', opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({translateZ: 0, translateY: '0px', opacity: 1}, {duration: speed, delay: delay});
                }

                if (anim === 'fadeDown') {
                    $(this).velocity({translateZ: 0, translateY: '30px', opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({translateZ: 0, translateY: '0px', opacity: 1}, {duration: speed, delay: delay});
                }

                if (anim === 'fadeLeft') {
                    $(this).velocity({translateZ: 0, translateX: '-30px', opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({translateZ: 0, translateX: '0px', opacity: 1}, {duration: speed, delay: delay});
                }

                if (anim === 'fadeRight') {
                    $(this).velocity({translateZ: 0, translateX: '30px', opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({translateZ: 0, translateX: '0px', opacity: 1}, {duration: speed, delay: delay});
                }

                if (anim === 'fadeIn') {
                    $(this).velocity({opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({opacity: 1}, {duration: speed, delay: delay});
                }

            }
        });
    };

    $('.anim').each(function () {
        $(this).addClass('start').css('opacity', 0);
    });

    /// load foundation
    $(document).foundation();


    $('#offCanvasMenu li a').click(() => {
        $('#offCanvas').foundation('close')
    });


    $('.cell-mh').matchHeight({ byRow: false });

    function lazy() {
        $('img.lazy').each(function () {
            if ($(this).isOnScreen()) {
                $(this).attr('src', $(this).attr('data-src'));
                $(this).removeClass('lazy');

                if ($(this).parent().hasClass('liquid')) {
                    $(this).parent().css('background-image', 'url(' + $(this).attr('data-src') + ')');
                }
            }
        });
    }
    lazy();

    $('.usps-slider').slick({
        dots: false,
        infinite: true,
        arrows: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    autoplay: true,
                    autoplaySpeed: 2000
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    $('.partners-slider').slick({
        dots: false,
        infinite: true,
        arrows: false,
        speed: 300,
        slidesToShow: 6,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 3000

                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    $('.liquid').imgLiquid();
    $('.banner-title-mh').matchHeight();
    $('.dienst-mh').matchHeight();
    $('.title-mh').matchHeight();

    $('#offCanvasMenu li a').click(() => {
        $('#offCanvas').foundation('close')
    });

    $('.pijltje').click(function(){
        $([document.documentElement, document.body]).animate({
            scrollTop: $(".pijltje").offset().top + 90
        }, 800);
    });

    /* =================================
    Timeline - Home
    ================================= */

    $(document).ready(function() {
        const carousel = {
            inIt: () => {
                $('.timeline-slider--carousel-owl').owlCarousel({
                    loop: true,
                    mouseDrag: false,
                    touchDrag: false,
                    pullDrag: false,
                    margin: 30,
                    responsiveClass:true,
                    dots:false,
                    responsive:{
                        0:{
                            items:2,
                            nav:false
                        },
                        400:{
                            items:2,
                            nav:false
                        },
                        600:{
                            items:3,
                            nav:false
                        },
                        768: {
                            items:4,
                            nav:false
                        },
                        1000:{
                            items:5,
                            nav:false
                        }
                    }
                });
            },
            randomheight: () => { // Give Random Height to Slider Elements
                if($(window).width() >= 720) {
                    return `${Math.floor(Math.random() * 200 )}px`; // for large screens
                } else {
                    return `${Math.floor(Math.random() * 105 )}px`; // for small screens
                }
            },
            nextItem: () => {
                carousel.fadeOut();
                $('.timeline-slider--carousel-owl').trigger('next.owl.carousel');
            },
            prevItem: () => {
                carousel.fadeOut();
                $('.timeline-slider--carousel-owl').trigger('prev.owl.carousel');
            },
            GetActiveData: () => { // Gets the data and adds to the slider Hero section
                $('.owl-item.active').each(function(i) {
                    if(i === 0) {
                        $('.timeline-slider--hero-date').text($(this).find('.date').text());
                        $('.timeline-text__heading').text($(this).find('.timeline-slider--carousel___item--heading').text());
                        $('.timeline-text__para').text($(this).find('.timeline-slider--carousel___item--para').text());
                        $('.timeline-slider--hero img').attr('src', $(this).find('img').attr('src'));
                    }
                })
            },
            fadeOut: () => {
                $('.timeline-text').css('opacity', '0');
                $('.timeline-slider--hero').fadeOut(500, function() {
                    carousel.fadeIn();
                    carousel.GetActiveData();
                });
            },
            fadeIn: () => {
                $('.timeline-slider--hero').fadeIn(500, function() {
                    $('.timeline-text').css('opacity', '1');
                    $(this).css('display', 'grid');
                });
            }
        };

        $( window ).resize(function() {
            $('.timeline-slider--carousel___item').each(function() {
                $(this).css('min-height', carousel.randomheight()); //disable this line for stop generating random height
            });

        });
        $('.timeline-slider--carousel___item').each(function() {
            $(this).css('min-height', carousel.randomheight()); //disable this line for stop generating random height
        });

        // Carousel Initialization
        carousel.inIt();


        // Previous Button Event Listener
        $('.timeline-nav__prev').click(function() {
            carousel.prevItem();
        });

        // Next+ Button Event Listener
        $('.timeline-nav__next').click(function() {
            carousel.nextItem();
        });


        carousel.GetActiveData();

    });

    $('.tab').click(function(){ // General click event
        if($(this).hasClass('noclick')){}else{
            $('.tab.active').addClass('inactive');
            $('.tab.active').removeClass('active'); // Add inactive and remove active class

            $(this).addClass('active');
            $(this).removeClass('inactive'); // Add active class and remove inactive class
        }
    });

    $('document').ready(function(){
        $('.load-overlay').fadeOut('slow');
    });



})(jQuery); // Fully reference jQuery after this point.